// ============================================================
// 管理端后端地址配置 —— 请在此处手动填写
// ------------------------------------------------------------
// 方式一（推荐，同域部署）：留空字符串 ''
//   前端通过相对路径 /api/admin/login 调用，
//   由你的 nginx 把 /api 反代到后端 3000 端口，无需跨域。
//
// 方式二（跨域）：填写完整地址，例如 'https://api.capturedslr.cc'
//   注意：结尾不要带斜杠。
//   实际请求地址 = API_BASE_URL + '/api/admin/login'
// ============================================================
export const API_BASE_URL = 'https://api.capturedslr.cc'



// WEBPACK FOOTER //
// ./src/admin/config.js